// ─── SCROLL PROGRESS BAR ──────────────────────────────────
window.addEventListener('scroll', () => {
  const scrollBar = document.getElementById('scroll-bar');
  if (!scrollBar) return;
  const h = document.documentElement.scrollHeight - window.innerHeight;
  scrollBar.style.width = (window.scrollY / h * 100) + '%';
}, { passive: true });

// ─── CURSOR ──────────────────────────────────────────────
const cursor = document.getElementById('cursor');
const follower = document.getElementById('cursor-follower');
const cursorLabel = document.getElementById('cursor-label');
let mx = 0, my = 0, fx = 0, fy = 0;
if (cursor) {
  document.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    cursor.style.left = mx + 'px'; cursor.style.top = my + 'px';
    if (cursorLabel) { cursorLabel.style.left = mx + 'px'; cursorLabel.style.top = my + 'px'; }
  });
  function animFollower() {
    fx += (mx - fx) * .12; fy += (my - fy) * .12;
    if (follower) { follower.style.left = fx + 'px'; follower.style.top = fy + 'px'; }
    requestAnimationFrame(animFollower);
  }
  animFollower();
  document.querySelectorAll('a,button,.product-card,.collection-panel,.look-item').forEach(el => {
    el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); if (follower) follower.classList.add('hover'); });
    el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); if (follower) follower.classList.remove('hover'); });
  });
}

// ─── CURSOR LABEL ──────────────────────────────────────────
function initCursorLabel() {
  document.querySelectorAll('.product-card, .collection-panel, .look-item').forEach(el => {
    el.addEventListener('mouseenter', () => { if (cursorLabel) cursorLabel.classList.add('visible'); });
    el.addEventListener('mouseleave', () => { if (cursorLabel) cursorLabel.classList.remove('visible'); });
  });
}

// ─── SPLIT TEXT REVEAL ────────────────────────────────────
function initSplitText() {
  document.querySelectorAll('.section-title, .story-title, .panel-name').forEach(el => {
    if (el.dataset.split) return;
    el.dataset.split = true;
    const html = el.innerHTML;
    const tokens = html.split(/(<br\s*\/?>)/i);
    let delay = 0;
    el.innerHTML = tokens.map(token => {
      if (/<br/i.test(token)) return token;
      return token.split(' ').filter(w => w).map(w =>
        `<span class="word"><span class="char" style="transition-delay:${delay++ * 0.06}s">${w}</span></span>`
      ).join(' ');
    }).join('');
    el.classList.add('split-title');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { el.classList.add('visible'); obs.unobserve(el); } });
    }, { threshold: 0.3 });
    obs.observe(el);
  });
}

// ─── REVEAL DIRECTIONS ────────────────────────────────────
function initRevealDirections() {
  document.querySelectorAll('.featured-row > *:first-child').forEach(el => el.classList.add('reveal-left'));
  document.querySelectorAll('.featured-row > *:last-child').forEach(el => el.classList.add('reveal-right'));
  document.querySelectorAll('.story-inner > *:first-child').forEach(el => el.classList.add('reveal-left'));
  document.querySelectorAll('.story-inner > *:last-child').forEach(el => el.classList.add('reveal-right'));
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal-left, .reveal-right').forEach(el => obs.observe(el));
}

// ─── 3D TILT EFFECT ───────────────────────────────────────
function initTilt() {
  document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = `perspective(800px) rotateY(${x * 12}deg) rotateX(${-y * 12}deg) scale(1.02)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'perspective(800px) rotateY(0) rotateX(0) scale(1)';
    });
  });
}

// ─── SCROLL REVEAL ───────────────────────────────────────
function triggerReveal() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: .1 });
  document.querySelectorAll('.reveal:not(.visible)').forEach(el => io.observe(el));
}

// ─── TOAST ────────────────────────────────────────────────
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2800);
}

// ─── CART DRAWER ──────────────────────────────────────────
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

// ─── SHOPIFY CART API ─────────────────────────────────────
async function fetchCart() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  renderCartDrawer(cart);
}

function renderCartDrawer(cart) {
  const itemsEl = document.getElementById('cart-items');
  const footerEl = document.getElementById('cart-footer');
  const totalEl = document.getElementById('cart-total');
  const countEl = document.getElementById('cart-count');

  if (countEl) countEl.textContent = cart.item_count;

  if (!cart.item_count) {
    itemsEl.innerHTML = '<div class="cart-empty"><div class="cart-empty-icon">○</div><p>Votre panier est vide</p></div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';
  if (totalEl) totalEl.textContent = (cart.total_price / 100).toFixed(0) + '€';

  itemsEl.innerHTML = cart.items.map((item, i) => `
    <div class="cart-item">
      <div class="cart-item-img"><img src="${item.image}" alt="${item.title}"></div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-col">${item.variant_title || ''}</div>
        <div class="cart-item-row">
          <div class="cart-item-qty">
            <button class="qty-btn" onclick="updateCartItem(${item.key}, ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button class="qty-btn" onclick="updateCartItem(${item.key}, ${item.quantity + 1})">+</button>
          </div>
          <span class="cart-item-price">${(item.final_line_price / 100).toFixed(0)}€</span>
        </div>
        <button class="cart-item-remove" onclick="updateCartItem(${item.key}, 0)">Supprimer</button>
      </div>
    </div>`).join('');
}

async function addToCart(variantId) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
  if (res.ok) {
    showToast('Produit ajouté au panier');
    openCart();
    updateCartCount();
  }
}

async function updateCartItem(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  fetchCart();
  updateCartCount();
}

async function updateCartCount() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const el = document.getElementById('cart-count');
  if (el) el.textContent = cart.item_count;
}

// ─── PRODUCT GALLERY THUMBS ───────────────────────────────
function switchPPImg(thumb, src) {
  const mainImg = document.getElementById('pp-main-img');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.pp-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// ─── SCROLL PRODUCTS ──────────────────────────────────────
function scrollProducts(id, dir) {
  const el = document.getElementById(id);
  if (el) el.scrollBy({ left: dir * 320, behavior: 'smooth' });
}

// ─── MOBILE MENU ─────────────────────────────────────────
function toggleMenu() {
  const m = document.getElementById('mobile-menu');
  if (!m) return;
  m.classList.toggle('open');
  document.body.style.overflow = m.classList.contains('open') ? 'hidden' : '';
}

// ─── SCROLL NAV ──────────────────────────────────────────
const isHomePage = document.body.classList.contains('template-index');
window.addEventListener('scroll', () => {
  const nav = document.getElementById('navbar');
  if (!nav) return;
  if (isHomePage) {
    if (window.scrollY > 80) { nav.classList.add('scrolled'); nav.classList.remove('dark'); }
    else { nav.classList.remove('scrolled'); nav.classList.add('dark'); }
  } else {
    if (window.scrollY > 20) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  }
}, { passive: true });

// ─── NEWSLETTER FORM ─────────────────────────────────────
function handleNewsletter(e) {
  e.preventDefault();
  showToast('Merci ! Vous êtes inscrit(e) à la newsletter KLAY');
  e.target.reset();
}

// ─── KEYBOARD NAV ────────────────────────────────────────
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeCart();
    const m = document.getElementById('mobile-menu');
    if (m && m.classList.contains('open')) toggleMenu();
  }
});

// ─── INIT ─────────────────────────────────────────────────
window.addEventListener('load', () => {
  setTimeout(() => {
    const loader = document.getElementById('loader');
    if (loader) loader.classList.add('out');
    if (isHomePage) {
      const nav = document.getElementById('navbar');
      if (nav) nav.classList.add('dark');
    }
    updateCartCount();
    initTilt();
    initCursorLabel();
    initSplitText();
    initRevealDirections();
    triggerReveal();
  }, 2400);
});
